// This is a replacement for `src/rxdb/syncReplicationStatesWithGraphQL.ts`
import {
  borerDocumentUploadPullModifier,
  borerDocumentUploadPullQueryBuilder,
} from '@/rxdb/BorerDocuments/queryBuilder';

import { SYNC_LIMIT_50, SYNC_LIMIT_HIGH, SYNC_LIMIT_LOW } from '../../utilities/constants';
import { advancesPullQueryBuilder, advancesPushQueryBuilder } from '../Advance/queryBuilder';
import { assignmentPullQueryBuilder } from '../Assignment/queryBuilder';
import { assignmentEmployeePullQueryBuilder } from '../AssignmentEmployee/queryBuilder';
import { assignmentRolePullQueryBuilder } from '../AssignmentRole/queryBuilder';
import { blocksPullQueryBuilder } from '../Blocks/queryBuilder';
import {
  borerActivityPullQueryBuilder,
  borerActivityPushModifer,
  borerActivityPushQueryBuilder,
} from '../BorerActivity/queryBuilder';
import { borerActivityTypePullQueryBuilder } from '../BorerActivityType/queryBuilder';
import { borerShiftPullQueryBuilder } from '../BorerShift/queryBuilder';
import {
  borerShiftActivityEmployeePullQueryBuilder,
  borerShiftActivityEmployeePushQueryBuilder,
} from '../BorerShiftActivityEmployees/queryBuilder';
import {
  borerShiftCommentPullQueryBuilder,
  borerShiftCommentPushQueryBuilder,
} from '../BorerShiftComment/queryBuilder';
import { borerShiftCommentTypePullQueryBuilder } from '../BorerShiftCommentType/queryBuilder';
import {
  borerShiftCrewPullModifier,
  borerShiftCrewPullQueryBuilder,
  borerShiftCrewPushQueryBuilder,
} from '../BorerShiftCrew/queryBuilder';
import {
  borerShiftCrewMemberPullQueryBuilder,
  borerShiftCrewMemberPushModifier,
  borerShiftCrewMemberPushQueryBuilder,
} from '../BorerShiftCrewMember/queryBuilder';
import { BorerShiftCrewMemberRolePullQueryBuilder } from '../BorerShiftCrewMemberRole/queryBuilder';
import {
  borerShiftInfoPullQueryBuilder,
  borerShiftInfoPushQueryBuilder,
} from '../BorerShiftInfo/queryBuilder';
import {
  borerShiftSignaturePullQueryBuilder,
  borerShiftSignaturePushQueryBuilder,
  SIGNATURE_BATCH_SIZE,
  SIGNATURE_SYNC_INTERVAL,
} from '../BorerShiftSignature/queryBuilder';
import { borerShiftTargetsPullQueryBuilder } from '../BorerShiftTarget/queryBuilder';
import { borerStateTypeCategoryPullQueryBuilder } from '../BorerStateTypeCategory/queryBuilder';
import { borerStateTypePullQueryBuilder } from '../BorerStateTypeFeed/queryBuilder';
import { LiveInterval } from '../constants';
import { crewPullQueryBuilder } from '../Crew/queryBuilder';
import { cuttingMethodPullQueryBuilder } from '../CuttingMethod/queryBuilder';
import {
  cuttingPermitSupervisorCommentPullQueryBuilder,
  cuttingPermitSupervisorCommentPushModifier,
  cuttingPermitSupervisorCommentPushQueryBuilder,
} from '../CuttingPermitSupervisorComment/queryBuilder';
import { cuttingTypePullQueryBuilder } from '../CuttingType/queryBuilder';
import { dailySafetyTopicsPullQueryBuilder } from '../DailySafetyTopic/queryBuilder';
import { delayActivityTypeCategoryPullQueryBuilder } from '../DelayActivityTypeCategory/queryBuilder';
import { departmentPullQueryBuilder } from '../Department/queryBuilder';
import {
  documentUploadPullModifier,
  documentUploadPullQueryBuilder,
} from '../Documents/queryBuilder';
import { documentTypePullQueryBuilder } from '../DocumentTypes/queryBuilder';
import { employeesPullQueryBuilder } from '../Employees/queryBuilder';
import {
  equipmentPullQueryBuilder,
  equipmentPushQueryBuilder,
  equipmentPushResponseModifier,
} from '../Equipment/queryBuilder';
import {
  equipmentDeficiencyPullQueryBuilder,
  equipmentDeficiencyPushQueryBuilder,
} from '../EquipmentDeficiency/queryBuilder';
import {
  equipmentDeficiencyAttachmentPullQueryBuilder,
  equipmentDeficiencyAttachmentPushQueryBuilder,
} from '../EquipmentDeficiencyAttachments/queryBuilder';
import {
  equipmentDeficiencyLogPullQueryBuilder,
  equipmentDeficiencyLogPushQueryBuilder,
} from '../EquipmentDeficiencyLog/queryBuilder';
import { equipmentStatusPullQueryBuilder } from '../EquipmentStatus/queryBuilder';
import { equipmentTypePullQueryBuilder } from '../EquipmentType/queryBuilder';
import {
  groundControlSetPushQueryBuilder,
  groundControlSetsPullModifier,
  groundControlSetsPullQueryBuilder,
  groundControlSetsPushModifier,
} from '../GroundControlSet/queryBuilder';
import { groundControlTypesPullQueryBuilder } from '../GroundControlTypes/queryBuilder';
import {
  groundHazardPullModifier,
  groundHazardPushQueryBuilder,
  groundHazardsPullQueryBuilder,
} from '../GroundHazard/queryBuilder';
import {
  groundHazardAttachmentPushQueryBuilder,
  groundHazardAttachmentsPullQueryBuilder,
} from '../GroundHazardAttachment/queryBuilder';
import {
  hazardLogPushQueryBuilder,
  hazardLogsPullQueryBuilder,
} from '../GroundHazardLog/queryBuilder';
import { groundHazardConditionTypePullQueryBuilder } from '../HazardConditionType/queryBuilder';
import { hazardSeverityPullQueryBuilder } from '../HazardSeverities/queryBuilder';
import { inspectionCategoriesPullQueryBuilder } from '../InspectionCategories/queryBuilder';
import { inspectionOptionsPullQueryBuilder } from '../InspectionOptions/queryBuilder';
import {
  inspectionResultPullQueryBuilder,
  inspectionResultPushModifier,
  inspectionResultPushQueryBuilder,
} from '../InspectionResults/queryBuilder';
import { inspectionPullQueryBuilder } from '../Inspections/queryBuilder';
import { inspectionSeverityPullQueryBuilder } from '../InspectionSeverityFeed/queryBuilder';
import { locationPushQueryBuilder, locationsPullQueryBuilder } from '../Locations/queryBuilder';
import { miningCutPullQueryBuilder } from '../MiningCut/queryBuilder';
import { miningPatternPullQueryBuilder } from '../MiningPattern/queryBuilder';
import {
  PANEL_DRAWING_BATCH_SIZE,
  PANEL_DRAWING_SYNC_INTERVAL,
  panelDrawingPullQueryBuilder,
  panelDrawingPushQueryBuilder,
} from '../PanelDrawing/queryBuilder';
import {
  panelDrawingCommentPullQueryBuilder,
  panelDrawingCommentPushQueryBuilder,
} from '../PanelDrawingComment/queryBuilder';
import { panelLogPushQueryBuilder, panelLogsPullQueryBuilder } from '../PanelLog/queryBuilder';
import { panelsPullQueryBuilder } from '../Panels/queryBuilder';
import { passesPullQueryBuilder } from '../Passes/queryBuilder';
import { positionPullQueryBuilder } from '../Position/queryBuilder';
import {
  predictionPullModifier,
  predictionPullQueryBuilder,
  predictionPushQueryBuilder,
} from '../Prediction/queryBuilder';
import {
  productionPullQueryBuilder,
  productionPushQueryBuilder,
} from '../Productions/queryBuilder';
import { roomsPullQueryBuilder } from '../Rooms/queryBuilder';
import { sequencesPullQueryBuilder } from '../Sequences/queryBuilder';
import { serviceStatusPullQueryBuilder } from '../ServiceStatus/queryBuilder';
import { shiftPullQueryBuilder } from '../Shifts/queryBuilder';
import {
  signaturePullQueryBuilder,
  signaturePushQueryBuilder,
} from '../Signature/rxdbSignatureDefinition';
import { sitePullQueryBuilder } from '../Site/queryBuilder';
import { supplyPullQueryBuilder, supplyPushQueryBuilder } from '../Supply/queryBuilder';
import { supplyItemPullQueryBuilder } from '../SupplyItem/queryBuilder';
import { surveyPointsPullQueryBuilder } from '../SurveyPoints/queryBuilder';
import { targetBorerRunningTimesPullQueryBuilder } from '../TargetBorerRunningTimes/queryBuilder';
import { workOrdersPullQueryBuilder } from '../WorkOrders/queryBuilder';
import { replicateBorerOperator } from './BorerOperator/replicateBorerOperator';
import { Database } from './Database';
import { Family } from './Family/Family';
import { createConfigBuilder, ReplicationState } from './replicate';
import { Replication } from './Replication';
import { RxdbCollectionNameV2 } from './RxdbCollectionNameV2';
import { syncGraphQLFor } from './syncGraphQLFor';

export async function syncReplicationStatesWithGraphQL(
  database: Database,
  idToken: string,
): Promise<Replication> {
  const replicationStates: ReplicationState<unknown>[] = [];
  const reSyncTimeouts: NodeJS.Timeout[] = [];
  const families: Family[] = [];

  // TODO: remove the need for this. https://nutrien.atlassian.net/browse/MDP-8188
  const live = true;

  const configBuilder = createConfigBuilder(idToken, database);

  const locationsState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.LOCATIONS,
    locationsPullQueryBuilder,
    undefined,
    locationPushQueryBuilder,
    null,
    false,
    live,
    LiveInterval.SECONDS_60,
    SYNC_LIMIT_HIGH,
  );
  if (locationsState) {
    replicationStates.push(locationsState.replicationState);
    reSyncTimeouts.push(locationsState.reSyncInterval);
  }

  const shiftState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.SHIFT,
    shiftPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (shiftState) {
    replicationStates.push(shiftState.replicationState);
    reSyncTimeouts.push(shiftState.reSyncInterval);
  }

  const borerShiftState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.BORER_SHIFT,
    borerShiftPullQueryBuilder,
    undefined,
    undefined,
    null,
    false,
    live,
  );
  if (borerShiftState) {
    replicationStates.push(borerShiftState.replicationState);
    reSyncTimeouts.push(borerShiftState.reSyncInterval);
  }

  const employeesState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.EMPLOYEES,
    employeesPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (employeesState) {
    replicationStates.push(employeesState.replicationState);
    reSyncTimeouts.push(employeesState.reSyncInterval);
  }

  const siteState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.SITES,
    sitePullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
    LiveInterval.MINUTES_15,
  );
  if (siteState) {
    replicationStates.push(siteState.replicationState);
    reSyncTimeouts.push(siteState.reSyncInterval);
  }

  const blocksState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.BLOCKS,
    blocksPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
    LiveInterval.MINUTES_15,
  );
  if (blocksState) {
    replicationStates.push(blocksState.replicationState);
    reSyncTimeouts.push(blocksState.reSyncInterval);
  }

  const panelsState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.PANELS,
    panelsPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (panelsState) {
    replicationStates.push(panelsState.replicationState);
    reSyncTimeouts.push(panelsState.reSyncInterval);
  }

  const roomsState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.ROOMS,
    roomsPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (roomsState) {
    replicationStates.push(roomsState.replicationState);
    reSyncTimeouts.push(roomsState.reSyncInterval);
  }

  const surveyPointsState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.SURVEY_POINTS,
    surveyPointsPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
    LiveInterval.SECONDS_60,
    SYNC_LIMIT_HIGH,
  );
  if (surveyPointsState) {
    replicationStates.push(surveyPointsState.replicationState);
    reSyncTimeouts.push(surveyPointsState.reSyncInterval);
  }

  const sequencesState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.SEQUENCES,
    sequencesPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (sequencesState) {
    replicationStates.push(sequencesState.replicationState);
    reSyncTimeouts.push(sequencesState.reSyncInterval);
  }

  const passState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.PASSES,
    passesPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (passState) {
    replicationStates.push(passState.replicationState);
    reSyncTimeouts.push(passState.reSyncInterval);
  }

  const hazardLogsState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.HAZARD_LOGS,
    hazardLogsPullQueryBuilder,
    undefined,
    hazardLogPushQueryBuilder,
    null, //createHazardLogPushModifier,
    false,
    live,
    undefined,
    undefined,
    undefined,
    7500,
  );
  if (hazardLogsState) {
    replicationStates.push(hazardLogsState.replicationState);
    reSyncTimeouts.push(hazardLogsState.reSyncInterval);
  }

  const groundHazardsState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.GROUND_HAZARDS,
    groundHazardsPullQueryBuilder,
    groundHazardPullModifier,
    groundHazardPushQueryBuilder,
    null,
    // groundHazardPushModifier,
    false,
    live,
    undefined,
    undefined,
    undefined,
    3000,
  );
  if (groundHazardsState) {
    replicationStates.push(groundHazardsState.replicationState);
    reSyncTimeouts.push(groundHazardsState.reSyncInterval);
  }

  const groundHazardConditionTypesState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.GROUND_HAZARD_CONDITION_TYPES,
    groundHazardConditionTypePullQueryBuilder,
    undefined,
    undefined,
    undefined,
    false,
    live,
  );
  if (groundHazardConditionTypesState) {
    replicationStates.push(groundHazardConditionTypesState.replicationState);
    reSyncTimeouts.push(groundHazardConditionTypesState.reSyncInterval);
  }

  const groundHazardAttachmentsState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.GROUND_HAZARDS_ATTACHMENTS,
    groundHazardAttachmentsPullQueryBuilder,
    undefined,
    groundHazardAttachmentPushQueryBuilder,
    null, //groundHazardAttachmentPushModifier,
    false,
    live,
  );
  if (groundHazardAttachmentsState) {
    replicationStates.push(groundHazardAttachmentsState.replicationState);
    reSyncTimeouts.push(groundHazardAttachmentsState.reSyncInterval);
  }

  const groundControlTypeState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.GROUND_CONTROL_TYPES,
    groundControlTypesPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
    LiveInterval.MINUTES_15,
  );
  if (groundControlTypeState) {
    replicationStates.push(groundControlTypeState.replicationState);
    reSyncTimeouts.push(groundControlTypeState.reSyncInterval);
  }

  const groundControlSetsState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.GROUND_CONTROL_SETS,
    groundControlSetsPullQueryBuilder,
    groundControlSetsPullModifier,
    groundControlSetPushQueryBuilder,
    groundControlSetsPushModifier,
    false,
    live,
    undefined,
    SYNC_LIMIT_HIGH,
    undefined,
    3000,
  );
  if (groundControlSetsState) {
    replicationStates.push(groundControlSetsState.replicationState);
    reSyncTimeouts.push(groundControlSetsState.reSyncInterval);
  }

  const signatureState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.SIGNATURES,
    signaturePullQueryBuilder,
    undefined,
    signaturePushQueryBuilder,
    null,
    false,
    live,
    SIGNATURE_SYNC_INTERVAL,
    SIGNATURE_BATCH_SIZE,
    undefined,
    3000,
  );

  if (signatureState) {
    replicationStates.push(signatureState.replicationState);
    reSyncTimeouts.push(signatureState.reSyncInterval);
  }

  const borerShiftSignatureState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.BORER_SHIFT_SIGNATURE,
    borerShiftSignaturePullQueryBuilder,
    undefined,
    borerShiftSignaturePushQueryBuilder,
    null,
    false,
    live,
    undefined,
    undefined,
    undefined,
    7500,
  );
  if (borerShiftSignatureState) {
    replicationStates.push(borerShiftSignatureState.replicationState);
    reSyncTimeouts.push(borerShiftSignatureState.reSyncInterval);
  }

  const inspectionsState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.INSPECTIONS,
    inspectionPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (inspectionsState) {
    replicationStates.push(inspectionsState.replicationState);
    reSyncTimeouts.push(inspectionsState.reSyncInterval);
  }

  const inspectionCategoriesState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.INSPECTION_CATEGORIES,
    inspectionCategoriesPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (inspectionCategoriesState) {
    replicationStates.push(inspectionCategoriesState.replicationState);
    reSyncTimeouts.push(inspectionCategoriesState.reSyncInterval);
  }

  const inspectionOptionsState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.INSPECTION_OPTIONS,
    inspectionOptionsPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (inspectionOptionsState) {
    replicationStates.push(inspectionOptionsState.replicationState);
    reSyncTimeouts.push(inspectionOptionsState.reSyncInterval);
  }

  const inspectionSeverityState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.INSPECTION_SEVERITY,
    inspectionSeverityPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (inspectionSeverityState) {
    replicationStates.push(inspectionSeverityState.replicationState);
    reSyncTimeouts.push(inspectionSeverityState.reSyncInterval);
  }

  const hazardSeveritiesState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.HAZARD_SEVERITIES,
    hazardSeverityPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (hazardSeveritiesState) {
    replicationStates.push(hazardSeveritiesState.replicationState);
    reSyncTimeouts.push(hazardSeveritiesState.reSyncInterval);
  }

  const inspectionResultsState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.INSPECTION_RESULTS,
    inspectionResultPullQueryBuilder,
    undefined,
    inspectionResultPushQueryBuilder,
    inspectionResultPushModifier,
    false,
    live,
    LiveInterval.SECONDS_60,
    SYNC_LIMIT_50,
    undefined,
    7500,
  );
  if (inspectionResultsState) {
    replicationStates.push(inspectionResultsState.replicationState);
    reSyncTimeouts.push(inspectionResultsState.reSyncInterval);
  }

  const cuttingPermitSupervisorCommentState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.CUTTING_PERMIT_SUPERVISOR_COMMENT,
    cuttingPermitSupervisorCommentPullQueryBuilder,
    undefined,
    cuttingPermitSupervisorCommentPushQueryBuilder,
    cuttingPermitSupervisorCommentPushModifier,
    false,
    live,
    LiveInterval.SECONDS_60,
    SYNC_LIMIT_50,
    undefined,
    7500,
  );
  if (cuttingPermitSupervisorCommentState) {
    replicationStates.push(cuttingPermitSupervisorCommentState.replicationState);
    reSyncTimeouts.push(cuttingPermitSupervisorCommentState.reSyncInterval);
  }

  const equipmentTypeState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.EQUIPMENT_TYPE,
    equipmentTypePullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
    LiveInterval.MINUTES_15,
  );
  if (equipmentTypeState) {
    replicationStates.push(equipmentTypeState.replicationState);
    reSyncTimeouts.push(equipmentTypeState.reSyncInterval);
  }

  const equipmentState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.EQUIPMENT,
    equipmentPullQueryBuilder,
    null,
    equipmentPushQueryBuilder,
    null,
    false,
    live,
    LiveInterval.SECONDS_30,
    SYNC_LIMIT_LOW,
    undefined,
    3000,
    undefined,
    equipmentPushResponseModifier,
  );
  if (equipmentState) {
    replicationStates.push(equipmentState.replicationState);
    reSyncTimeouts.push(equipmentState.reSyncInterval);
  }

  const equipmentStatusState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.EQUIPMENT_STATUS,
    equipmentStatusPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
    LiveInterval.MINUTES_15,
  );
  if (equipmentStatusState) {
    replicationStates.push(equipmentStatusState.replicationState);
    reSyncTimeouts.push(equipmentStatusState.reSyncInterval);
  }

  const equipmentDeficiencyState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.EQUIPMENT_DEFICIENCY,
    equipmentDeficiencyPullQueryBuilder,
    undefined,
    equipmentDeficiencyPushQueryBuilder,
    null,
    false,
    live,
  );
  if (equipmentDeficiencyState) {
    replicationStates.push(equipmentDeficiencyState.replicationState);
    reSyncTimeouts.push(equipmentDeficiencyState.reSyncInterval);
  }

  const equipmentDeficiencyLogState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.EQUIPMENT_DEFICIENCY_LOG,
    equipmentDeficiencyLogPullQueryBuilder,
    undefined,
    equipmentDeficiencyLogPushQueryBuilder,
    null,
    false,
    live,
  );
  if (equipmentDeficiencyLogState) {
    replicationStates.push(equipmentDeficiencyLogState.replicationState);
    reSyncTimeouts.push(equipmentDeficiencyLogState.reSyncInterval);
  }

  const equipmentDeficiencyAttachmentState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.EQUIPMENT_DEFICIENCY_ATTACHMENT,
    equipmentDeficiencyAttachmentPullQueryBuilder,
    undefined,
    equipmentDeficiencyAttachmentPushQueryBuilder,
    null,
    false,
    live,
  );
  if (equipmentDeficiencyAttachmentState) {
    replicationStates.push(equipmentDeficiencyAttachmentState.replicationState);
    reSyncTimeouts.push(equipmentDeficiencyAttachmentState.reSyncInterval);
  }

  const borerActivityState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.BORER_ACTIVITY,
    borerActivityPullQueryBuilder,
    undefined,
    borerActivityPushQueryBuilder,
    borerActivityPushModifer,
    false,
    live,
  );
  if (borerActivityState) {
    replicationStates.push(borerActivityState.replicationState);
    reSyncTimeouts.push(borerActivityState.reSyncInterval);
  }

  const borerActivityTypeState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.BORER_ACTIVITY_TYPE,
    borerActivityTypePullQueryBuilder,
    undefined,
    null,
    null,
    false,
    live,
    LiveInterval.MINUTES_15,
  );
  if (borerActivityTypeState) {
    replicationStates.push(borerActivityTypeState.replicationState);
    reSyncTimeouts.push(borerActivityTypeState.reSyncInterval);
  }

  const delayActivityTypeCategoryState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.DELAY_ACTIVITY_TYPE_CATEGORY,
    delayActivityTypeCategoryPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (delayActivityTypeCategoryState) {
    replicationStates.push(delayActivityTypeCategoryState.replicationState);
    reSyncTimeouts.push(delayActivityTypeCategoryState.reSyncInterval);
  }

  const workOrdersState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.WORK_ORDERS,
    workOrdersPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (workOrdersState) {
    replicationStates.push(workOrdersState.replicationState);
    reSyncTimeouts.push(workOrdersState.reSyncInterval);
  }

  const borerShiftActivityEmployeeState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.BORER_SHIFT_ACTIVITY_EMPLOYEES,
    borerShiftActivityEmployeePullQueryBuilder,
    undefined,
    borerShiftActivityEmployeePushQueryBuilder,
    null,
    false,
    live,
  );
  if (borerShiftActivityEmployeeState) {
    replicationStates.push(borerShiftActivityEmployeeState.replicationState);
    reSyncTimeouts.push(borerShiftActivityEmployeeState.reSyncInterval);
  }

  const borerShiftCrewState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.BORER_SHIFT_CREW,
    borerShiftCrewPullQueryBuilder,
    borerShiftCrewPullModifier,
    borerShiftCrewPushQueryBuilder,
    null,
    true,
    live,
  );
  if (borerShiftCrewState) {
    replicationStates.push(borerShiftCrewState.replicationState);
    reSyncTimeouts.push(borerShiftCrewState.reSyncInterval);
  }

  const borerShiftCrewMemberState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.BORER_SHIFT_CREW_MEMBER,
    borerShiftCrewMemberPullQueryBuilder,
    undefined,
    borerShiftCrewMemberPushQueryBuilder,
    borerShiftCrewMemberPushModifier,
    false,
    live,
  );
  if (borerShiftCrewMemberState) {
    replicationStates.push(borerShiftCrewMemberState.replicationState);
    reSyncTimeouts.push(borerShiftCrewMemberState.reSyncInterval);
  }

  const borerShiftAdvanceState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.BORER_SHIFT_ADVANCE,
    advancesPullQueryBuilder,
    undefined,
    advancesPushQueryBuilder,
    null,
    false,
    live,
    undefined,
    undefined,
    undefined,
    3000,
  );
  if (borerShiftAdvanceState) {
    replicationStates.push(borerShiftAdvanceState.replicationState);
    reSyncTimeouts.push(borerShiftAdvanceState.reSyncInterval);
  }

  const borerShiftProductionState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.BORER_SHIFT_PRODUCTION,
    productionPullQueryBuilder,
    null,
    productionPushQueryBuilder,
    null,
    false,
    live,
    undefined,
    undefined,
    undefined,
    7500,
  );
  if (borerShiftProductionState) {
    replicationStates.push(borerShiftProductionState.replicationState);
    reSyncTimeouts.push(borerShiftProductionState.reSyncInterval);
  }

  const borerShiftPredictionState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.BORER_SHIFT_PREDICTION,
    predictionPullQueryBuilder,
    predictionPullModifier,
    predictionPushQueryBuilder,
    null,
    false,
    live,
  );
  if (borerShiftPredictionState) {
    replicationStates.push(borerShiftPredictionState.replicationState);
    reSyncTimeouts.push(borerShiftPredictionState.reSyncInterval);
  }

  const miningCutState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.MINING_CUTS,
    miningCutPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (miningCutState) {
    replicationStates.push(miningCutState.replicationState);
    reSyncTimeouts.push(miningCutState.reSyncInterval);
  }

  const assignmentRoleState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.ASSIGNMENT_ROLE,
    assignmentRolePullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (assignmentRoleState) {
    replicationStates.push(assignmentRoleState.replicationState);
    reSyncTimeouts.push(assignmentRoleState.reSyncInterval);
  }

  const assignmentEmployeeState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.ASSIGNMENT_EMPLOYEE,
    assignmentEmployeePullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (assignmentEmployeeState) {
    replicationStates.push(assignmentEmployeeState.replicationState);
    reSyncTimeouts.push(assignmentEmployeeState.reSyncInterval);
  }

  const assignmentState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.ASSIGNMENT,
    assignmentPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (assignmentState) {
    replicationStates.push(assignmentState.replicationState);
    reSyncTimeouts.push(assignmentState.reSyncInterval);
  }

  const panelDrawingState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.PANEL_DRAWINGS,
    panelDrawingPullQueryBuilder,
    undefined,
    panelDrawingPushQueryBuilder,
    null,
    false,
    live,
    PANEL_DRAWING_SYNC_INTERVAL,
    PANEL_DRAWING_BATCH_SIZE,
  );
  if (panelDrawingState) {
    replicationStates.push(panelDrawingState.replicationState);
    reSyncTimeouts.push(panelDrawingState.reSyncInterval);
  }

  const panelDrawingCommentState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.PANEL_DRAWING_COMMENTS,
    panelDrawingCommentPullQueryBuilder,
    undefined,
    panelDrawingCommentPushQueryBuilder,
    null,
    false,
    live,
  );
  if (panelDrawingCommentState) {
    replicationStates.push(panelDrawingCommentState.replicationState);
    reSyncTimeouts.push(panelDrawingCommentState.reSyncInterval);
  }

  const dailySafetyTopicsState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.DAILY_SAFETY_TOPIC,
    dailySafetyTopicsPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
    LiveInterval.MINUTES_15,
  );
  if (dailySafetyTopicsState) {
    replicationStates.push(dailySafetyTopicsState.replicationState);
    reSyncTimeouts.push(dailySafetyTopicsState.reSyncInterval);
  }

  const borerShiftInfoState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.BORER_SHIFT_INFO,
    borerShiftInfoPullQueryBuilder,
    undefined,
    borerShiftInfoPushQueryBuilder,
    null,
    false,
    live,
  );
  if (borerShiftInfoState) {
    replicationStates.push(borerShiftInfoState.replicationState);
    reSyncTimeouts.push(borerShiftInfoState.reSyncInterval);
  }

  const documentUploadState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.DOCUMENT_UPLOAD,
    documentUploadPullQueryBuilder,
    documentUploadPullModifier,
    null,
    null,
    false,
    live,
  );
  if (documentUploadState) {
    replicationStates.push(documentUploadState.replicationState);
    reSyncTimeouts.push(documentUploadState.reSyncInterval);
  }

  const borerDocumentUploadState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.BORER_DOCUMENT_UPLOAD,
    borerDocumentUploadPullQueryBuilder,
    borerDocumentUploadPullModifier,
    null,
    null,
    false,
    live,
  );
  if (borerDocumentUploadState) {
    replicationStates.push(borerDocumentUploadState.replicationState);
    reSyncTimeouts.push(borerDocumentUploadState.reSyncInterval);
  }

  const documentTypeState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.DOCUMENT_TYPES,
    documentTypePullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
    LiveInterval.MINUTES_15,
  );
  if (documentTypeState) {
    replicationStates.push(documentTypeState.replicationState);
    reSyncTimeouts.push(documentTypeState.reSyncInterval);
  }

  // Supply Subscription Spike
  const supplyState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.SUPPLIES,
    supplyPullQueryBuilder,
    null,
    supplyPushQueryBuilder,
    null,
    false,
    live,
    LiveInterval.SECONDS_60,
  );
  if (supplyState) {
    replicationStates.push(supplyState.replicationState);
    reSyncTimeouts.push(supplyState.reSyncInterval);
  }

  const supplyItemState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.SUPPLY_ITEMS,
    supplyItemPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (supplyItemState) {
    replicationStates.push(supplyItemState.replicationState);
    reSyncTimeouts.push(supplyItemState.reSyncInterval);
  }

  const serviceStatusState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.SERVICE_STATUS,
    serviceStatusPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (serviceStatusState) {
    replicationStates.push(serviceStatusState.replicationState);
    reSyncTimeouts.push(serviceStatusState.reSyncInterval);
  }

  const targetBorerRunningTimeState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.TARGET_BORER_RUNNING_TIMES,
    targetBorerRunningTimesPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (targetBorerRunningTimeState) {
    replicationStates.push(targetBorerRunningTimeState.replicationState);
    reSyncTimeouts.push(targetBorerRunningTimeState.reSyncInterval);
  }

  const crewState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.CREWS,
    crewPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (crewState) {
    replicationStates.push(crewState.replicationState);
    reSyncTimeouts.push(crewState.reSyncInterval);
  }

  const positionState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.POSITIONS,
    positionPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (positionState) {
    replicationStates.push(positionState.replicationState);
    reSyncTimeouts.push(positionState.reSyncInterval);
  }

  const miningPatternState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.MINING_PATTERN,
    miningPatternPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (miningPatternState) {
    replicationStates.push(miningPatternState.replicationState);
    reSyncTimeouts.push(miningPatternState.reSyncInterval);
  }

  const departmentState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.DEPARTMENT,
    departmentPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (departmentState) {
    replicationStates.push(departmentState.replicationState);
    reSyncTimeouts.push(departmentState.reSyncInterval);
  }

  const borerShiftCommentState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.BORER_SHIFT_COMMENT,
    borerShiftCommentPullQueryBuilder,
    null,
    borerShiftCommentPushQueryBuilder,
    null,
    false,
    live,
  );
  if (borerShiftCommentState) {
    replicationStates.push(borerShiftCommentState.replicationState);
    reSyncTimeouts.push(borerShiftCommentState.reSyncInterval);
  }

  const borerShiftCommentTypeState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.BORER_SHIFT_COMMENT_TYPE,
    borerShiftCommentTypePullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
    LiveInterval.MINUTES_15,
  );
  if (borerShiftCommentTypeState) {
    replicationStates.push(borerShiftCommentTypeState.replicationState);
    reSyncTimeouts.push(borerShiftCommentTypeState.reSyncInterval);
  }

  const panelLogState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.PANEL_LOGS,
    panelLogsPullQueryBuilder,
    null,
    panelLogPushQueryBuilder,
    null,
    false,
    live,
  );
  if (panelLogState) {
    replicationStates.push(panelLogState.replicationState);
    reSyncTimeouts.push(panelLogState.reSyncInterval);
  }

  const borerShiftTargetState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.BORER_SHIFT_TARGET,
    borerShiftTargetsPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (borerShiftTargetState) {
    replicationStates.push(borerShiftTargetState.replicationState);
    reSyncTimeouts.push(borerShiftTargetState.reSyncInterval);
  }
  const BorerShiftCrewMemberRoleState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.BORER_SHIFT_CREW_MEMBER_ROLE,
    BorerShiftCrewMemberRolePullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
  );
  if (BorerShiftCrewMemberRoleState) {
    replicationStates.push(BorerShiftCrewMemberRoleState.replicationState);
    reSyncTimeouts.push(BorerShiftCrewMemberRoleState.reSyncInterval);
  }

  replicateBorerOperator(database, configBuilder, replicationStates, reSyncTimeouts);

  const borerStateTypeState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.BORER_STATE_TYPE,
    borerStateTypePullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
    LiveInterval.MINUTES_15,
    SYNC_LIMIT_LOW,
  );
  if (borerStateTypeState) {
    replicationStates.push(borerStateTypeState.replicationState);
    reSyncTimeouts.push(borerStateTypeState.reSyncInterval);
  }

  const borerStateTypeCategoryState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.BORER_STATE_TYPE_CATEGORY,
    borerStateTypeCategoryPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
    LiveInterval.MINUTES_30,
    SYNC_LIMIT_LOW,
  );
  if (borerStateTypeCategoryState) {
    replicationStates.push(borerStateTypeCategoryState.replicationState);
    reSyncTimeouts.push(borerStateTypeCategoryState.reSyncInterval);
  }

  const cuttingTypeState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.CUTTING_TYPE,
    cuttingTypePullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
    LiveInterval.MINUTES_30,
    SYNC_LIMIT_LOW,
  );
  if (cuttingTypeState) {
    replicationStates.push(cuttingTypeState.replicationState);
    reSyncTimeouts.push(cuttingTypeState.reSyncInterval);
  }

  const cuttingMethodState = syncGraphQLFor(
    idToken,
    database,
    RxdbCollectionNameV2.CUTTING_METHOD,
    cuttingMethodPullQueryBuilder,
    null,
    null,
    null,
    false,
    live,
    LiveInterval.MINUTES_30,
    SYNC_LIMIT_LOW,
  );
  if (cuttingMethodState) {
    replicationStates.push(cuttingMethodState.replicationState);
    reSyncTimeouts.push(cuttingMethodState.reSyncInterval);
  }

  return {
    families,
    replicationStates,
    reSyncTimeouts,
  };
}
